import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { useSearchParams } from 'react-router-dom'
import { confirmSignUpWithVerificationCode } from '../../store/auth/authActions'
import { clearAuth, selectAuthenticatedUser, selectAuthMessage, selectBlockedLandingPageHtml } from '../../store/auth/authSlice'
import { useEffect } from 'react'
import * as React from 'react'
import { Redirect } from './Redirect'
import { useNavigateToOnboarding } from '../onboarding/hooks'
import './Auth.scss'
import { WAIT_LIST_MESSAGE } from './const'
import BlockedLandingPage from './errors/BlockedLandingPage'

const SignUpVerificationViewV2: React.FC = () => {
  const [searchParams] = useSearchParams()

  const dispatch = useAppDispatch()
  const navigateToOnboarding = useNavigateToOnboarding()

  const authMessage = useAppSelector(selectAuthMessage)
  const authenticatedUser = useAppSelector(selectAuthenticatedUser)
  const blockedLandingPageHtml = useAppSelector(selectBlockedLandingPageHtml)

  useEffect(() => {
    if (authenticatedUser) {
      navigateToOnboarding()
    }
  }, [navigateToOnboarding, authenticatedUser])

  useEffect(() => {
    if (authMessage === WAIT_LIST_MESSAGE) {
      dispatch(clearAuth())
      navigateToOnboarding('/wait-list')
    }
  }, [navigateToOnboarding, authMessage, dispatch])

  useEffect(() => {
    const email = searchParams.get('email') || ''
    const code = searchParams.get('code') || ''
    try {
      dispatch(confirmSignUpWithVerificationCode({ email, code }))
    } catch (e) {
      console.error(e)
    }
  }, [dispatch, searchParams])

  if (blockedLandingPageHtml) {
    return <BlockedLandingPage htmlContent={blockedLandingPageHtml} />
  }

  return <Redirect />
}

export default SignUpVerificationViewV2
